import { Injectable } from '@angular/core';
import {
  INotificationViewModelNotificationTotalTypePagedResultResponse,
  NotificationStatus,
  NotificationTotalType,
  NotificationTotalTypeITotal,
  NotificationViewModel,
  NotificationViewModelNotificationTotalTypePagedResultResponse,
  UsersClient,
} from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StoreNotificationService {
  static EMPTY = new NotificationViewModelNotificationTotalTypePagedResultResponse();
  subscription = new Subscription();
  notificationsSubject$ = new BehaviorSubject<INotificationViewModelNotificationTotalTypePagedResultResponse>(
    StoreNotificationService.EMPTY
  );
  allNotifications$ = this.notificationsSubject$.asObservable().pipe(
    filter((t) => t !== null),
    map((t) => this.orderByCreatedDate(t))
  );
  todayNotifications$ = this.allNotifications$.pipe(map((t) => this.getTodayNotifications(t.records)));
  yesterdayNotifications$ = this.allNotifications$.pipe(map((t) => this.getYesterdayNotifications(t.records)));
  moreNotifications$ = this.allNotifications$.pipe(map((t) => this.getMoreNotifications(t.records)));
  totalNewCount$ = this.allNotifications$.pipe(map((t) => this.getTotalUnread(t.totals)));

  getTotalUnread(totals: NotificationTotalTypeITotal[]) {
    const newItem = totals.find((t) => t.type === NotificationTotalType.New);
    return newItem ? newItem.value : 0;
  }
  getTotalAll(totals: NotificationTotalTypeITotal[]) {
    const allItem = totals.find((t) => t.type === NotificationTotalType.All);
    return allItem ? allItem.value : 0;
  }
  getTotalRead(totals: NotificationTotalTypeITotal[]) {
    const readItem = totals.find((t) => t.type === NotificationTotalType.Read);
    return readItem ? readItem.value : 0;
  }
  orderByCreatedDate(response: INotificationViewModelNotificationTotalTypePagedResultResponse) {
    const sorted = response.records.sort((a, b) => {
      return b.createdDate.getTime() - a.createdDate.getTime();
    });
    response.records = sorted;
    return response;
  }

  addNotifications(notifications: NotificationViewModel[]) {
    const model = this.notificationsSubject$.value;
    const unread = this.getTotalUnread(model.totals || []);
    const read = this.getTotalRead(model.totals || []);
    let all = this.getTotalAll(model.totals || []);
    if (all !== read + unread) {
      all = read + unread;
    }
    const updateModel = this.initNotifications({
      totals: [
        { type: NotificationTotalType.All, value: all + notifications.length },
        { type: NotificationTotalType.New, value: unread + notifications.length },
        { type: NotificationTotalType.Read, value: read },
      ],
      records: [...model.records, ...notifications],
    });

    this.notificationsSubject$.next(updateModel);
  }

  clearTotalsRead(totals: NotificationTotalTypeITotal[]) {
    const newItem = totals.find((t) => t.type === NotificationTotalType.New);
    let readItem = totals.find((t) => t.type === NotificationTotalType.Read);
    if (newItem && newItem.value > 0) {
      if (!readItem) {
        readItem = new NotificationTotalTypeITotal({ type: NotificationTotalType.Read, value: 0 });
      }
      readItem.value = readItem.value + newItem.value;
      newItem.value = 0;
      return [newItem, readItem];
    }
    return totals;
  }

  getTodayNotifications(notifications: NotificationViewModel[]) {
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    return notifications.filter((t) => t.createdDate > today);
  }

  getYesterdayNotifications(notifications: NotificationViewModel[]) {
    const yesterday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    yesterday.setDate(yesterday.getDate() - 1);

    console.log(yesterday);
    console.log(notifications);
    const n = notifications.filter(
      (t) =>
        t.createdDate.getFullYear() === yesterday.getFullYear() &&
        t.createdDate.getMonth() === yesterday.getMonth() &&
        t.createdDate.getDate() === yesterday.getDate()
    );
    console.log(n);
    return n;
  }

  getMoreNotifications(notifications: NotificationViewModel[]) {
    const yesterday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    yesterday.setDate(yesterday.getDate() - 1);
    return notifications.filter((t) => t.createdDate < yesterday);
  }

  constructor(private usersClient: UsersClient, private currentUser: AuthService) {
    StoreNotificationService.EMPTY.init(
      this.initNotifications({
        totals: [
          { type: NotificationTotalType.All, value: 0 },
          { type: NotificationTotalType.New, value: 0 },
          { type: NotificationTotalType.Read, value: 0 },
        ],
        records: [],
      })
    );
  }

  loadNotifications() {
    this.subscription.add(
      this.currentUser.activeUser$
        .pipe(
          filter((t) => t !== null),
          switchMap((t) => this.usersClient.getUserNotifications(1, 1000, [], [], t.uniqueId, undefined))
        )
        .subscribe((t) => {
          this.notificationsSubject$.next(t);
        })
    );
  }

  // tslint:disable-next-line: no-any
  initNotifications(data: any) {
    const notifications = new NotificationViewModelNotificationTotalTypePagedResultResponse();
    notifications.init(data);
    return notifications;
  }
  clear() {
    this.usersClient
      .editUserNotificationsStatus(this.currentUser.activeUser.uniqueId, undefined, NotificationStatus.Read)
      .toPromise()
      .then((t) => {
        const notifications = Object.assign({}, this.notificationsSubject$.value);
        console.log(notifications.totals);

        notifications.totals = this.clearTotalsRead(notifications.totals);
        this.notificationsSubject$.next(notifications);
      });
  }
}
